<template>
    <div id="customer-chart" class="md:w-3/4 w-full mb-base mx-auto">
        <div v-if="isLoaded" class="mt-base">
            <div class="total_customer" style="width: auto;">
                <div class="text-lg">Total customer</div>
                <div class="text-4xl font-bold mx-4 text-center mt-1">{{chartInfo.all}}</div>
            </div>
            <vue-apex-charts
                type="donut"
                height="300"
                :options="chartOptions"
                :series="series"
                class="chart"
            ></vue-apex-charts>
        </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import themeConfig from '../../../themeConfig'

export default {
    name: 'vs-customer-chart',
    components: {
        VueApexCharts
    },
    props: {
        // customerList: {
        //     type: Object,
        //     required: true
        // }
    },
    data() {
        // let series = this.getSeries();
        // let customerList = this.customerList;
        return {
          message: 'ff',
            series: [],
            // customerList: [],
            // series,
            // customerList: [],
            // customerList,
            chartOptions: {
                colors: [themeConfig.colors.success, themeConfig.colors.warning, themeConfig.colors.danger, themeConfig.colors.primary, themeConfig.colors.purple, themeConfig.colors.booking, themeConfig.colors.import],
                labels: ["New", "At risk", "Vip", "Regular", "Normal", "Booking", "Import"],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 300
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            isLoaded: false,
        }
    },
    computed: {
        chartInfo() {
            return this.$store.getters["customerList/chartInfo"];
        }
    },
    methods: {
        getSeries() {
            // let count = {
            //     new: 0,
            //     atrisk: 0,
            //     vip: 0,
            //     regular: 0,
            //     normal: 0
            // }
            // for(let i = 0; i < this.customerList.length; i++) {
            //     if(this.customerList[i].type == "new") { count.new++; }
            //     if(this.customerList[i].type == "atrisk") { count.atrisk++; }
            //     if(this.customerList[i].type == "vip") { count.vip++; }
            //     if(this.customerList[i].type == "regular") { count.regular++; }
            //     if(this.customerList[i].type == "normal") { count.normal++; }
            // }
            // // console.log([count.new, count.atrisk, count.vip, count.regular, count.normal]);
            // return [count.new, count.atrisk, count.vip, count.regular, count.normal];
            return [this.chartInfo.new, this.chartInfo.atrisk, this.chartInfo.vip, this.chartInfo.regular, this.chartInfo.normal, this.chartInfo.booking, this.chartInfo.import];
        }
    } ,
    created() {
        // this.series = this.getSeries();
        // this.customerList = this.$store.getters["customerList/customerList"];
        // this.$store.dispatch("customerList/GET_CUSTOMER_LIST").then((response) => {
        //     this.customerList = response;
        //     this.series = this.getSeries();
        // })
        let temp = this;
        this.$store.dispatch("customerList/GET_CHART_INFO").then(() => {
            // console.log(response)
            this.isLoaded = true;
            temp.$emit('CustomerChartLoadComplete');
            this.message = 'abc'
            this.series = this.getSeries();
        }).catch((err)=>{
          this.message = err
          temp.$emit('CustomerChartLoadComplete');
        })
    }
}
</script>
